import _slicedToArray from "/Users/dominikgyecsek/Projects/fms/flashcards/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _createClass from "/Users/dominikgyecsek/Projects/fms/flashcards/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _toConsumableArray from "/Users/dominikgyecsek/Projects/fms/flashcards/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/Users/dominikgyecsek/Projects/fms/flashcards/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/dominikgyecsek/Projects/fms/flashcards/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/dominikgyecsek/Projects/fms/flashcards/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/dominikgyecsek/Projects/fms/flashcards/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/dominikgyecsek/Projects/fms/flashcards/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/dominikgyecsek/Projects/fms/flashcards/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _wrapNativeSuper from "/Users/dominikgyecsek/Projects/fms/flashcards/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

/*! Capacitor: https://capacitorjs.com/ - MIT License */
var createCapacitorPlatforms = function createCapacitorPlatforms(win) {
  var defaultPlatformMap = new Map();
  defaultPlatformMap.set('web', {
    name: 'web'
  });
  var capPlatforms = win.CapacitorPlatforms || {
    currentPlatform: {
      name: 'web'
    },
    platforms: defaultPlatformMap
  };

  var addPlatform = function addPlatform(name, platform) {
    capPlatforms.platforms.set(name, platform);
  };

  var setPlatform = function setPlatform(name) {
    if (capPlatforms.platforms.has(name)) {
      capPlatforms.currentPlatform = capPlatforms.platforms.get(name);
    }
  };

  capPlatforms.addPlatform = addPlatform;
  capPlatforms.setPlatform = setPlatform;
  return capPlatforms;
};

var initPlatforms = function initPlatforms(win) {
  return win.CapacitorPlatforms = createCapacitorPlatforms(win);
};
/**
 * @deprecated Set `CapacitorCustomPlatform` on the window object prior to runtime executing in the web app instead
 */


var CapacitorPlatforms =
/*#__PURE__*/
initPlatforms(typeof globalThis !== 'undefined' ? globalThis : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {});
/**
 * @deprecated Set `CapacitorCustomPlatform` on the window object prior to runtime executing in the web app instead
 */

var addPlatform = CapacitorPlatforms.addPlatform;
/**
 * @deprecated Set `CapacitorCustomPlatform` on the window object prior to runtime executing in the web app instead
 */

var setPlatform = CapacitorPlatforms.setPlatform;

var legacyRegisterWebPlugin = function legacyRegisterWebPlugin(cap, webPlugin) {
  var _a;

  var config = webPlugin.config;
  var Plugins = cap.Plugins;

  if (!config || !config.name) {
    // TODO: add link to upgrade guide
    throw new Error("Capacitor WebPlugin is using the deprecated \"registerWebPlugin()\" function, but without the config. Please use \"registerPlugin()\" instead to register this web plugin.\"");
  } // TODO: add link to upgrade guide


  console.warn("Capacitor plugin \"".concat(config.name, "\" is using the deprecated \"registerWebPlugin()\" function"));

  if (!Plugins[config.name] || ((_a = config === null || config === void 0 ? void 0 : config.platforms) === null || _a === void 0 ? void 0 : _a.includes(cap.getPlatform()))) {
    // Add the web plugin into the plugins registry if there already isn't
    // an existing one. If it doesn't already exist, that means
    // there's no existing native implementation for it.
    // - OR -
    // If we already have a plugin registered (meaning it was defined in the native layer),
    // then we should only overwrite it if the corresponding web plugin activates on
    // a certain platform. For example: Geolocation uses the WebPlugin on Android but not iOS
    Plugins[config.name] = webPlugin;
  }
};

var ExceptionCode;

(function (ExceptionCode) {
  /**
   * API is not implemented.
   *
   * This usually means the API can't be used because it is not implemented for
   * the current platform.
   */
  ExceptionCode["Unimplemented"] = "UNIMPLEMENTED";
  /**
   * API is not available.
   *
   * This means the API can't be used right now because:
   *   - it is currently missing a prerequisite, such as network connectivity
   *   - it requires a particular platform or browser version
   */

  ExceptionCode["Unavailable"] = "UNAVAILABLE";
})(ExceptionCode || (ExceptionCode = {}));

var CapacitorException =
/*#__PURE__*/
function (_Error) {
  _inherits(CapacitorException, _Error);

  function CapacitorException(message, code, data) {
    var _this;

    _classCallCheck(this, CapacitorException);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CapacitorException).call(this, message));
    _this.message = message;
    _this.code = code;
    _this.data = data;
    return _this;
  }

  return CapacitorException;
}(_wrapNativeSuper(Error));

var getPlatformId = function getPlatformId(win) {
  var _a, _b;

  if (win === null || win === void 0 ? void 0 : win.androidBridge) {
    return 'android';
  } else if ((_b = (_a = win === null || win === void 0 ? void 0 : win.webkit) === null || _a === void 0 ? void 0 : _a.messageHandlers) === null || _b === void 0 ? void 0 : _b.bridge) {
    return 'ios';
  } else {
    return 'web';
  }
};

var createCapacitor = function createCapacitor(win) {
  var _a, _b, _c, _d, _e;

  var capCustomPlatform = win.CapacitorCustomPlatform || null;
  var cap = win.Capacitor || {};
  var Plugins = cap.Plugins = cap.Plugins || {};
  /**
   * @deprecated Use `capCustomPlatform` instead, default functions like registerPlugin will function with the new object.
   */

  var capPlatforms = win.CapacitorPlatforms;

  var defaultGetPlatform = function defaultGetPlatform() {
    return capCustomPlatform !== null ? capCustomPlatform.name : getPlatformId(win);
  };

  var getPlatform = ((_a = capPlatforms === null || capPlatforms === void 0 ? void 0 : capPlatforms.currentPlatform) === null || _a === void 0 ? void 0 : _a.getPlatform) || defaultGetPlatform;

  var defaultIsNativePlatform = function defaultIsNativePlatform() {
    return getPlatform() !== 'web';
  };

  var isNativePlatform = ((_b = capPlatforms === null || capPlatforms === void 0 ? void 0 : capPlatforms.currentPlatform) === null || _b === void 0 ? void 0 : _b.isNativePlatform) || defaultIsNativePlatform;

  var defaultIsPluginAvailable = function defaultIsPluginAvailable(pluginName) {
    var plugin = registeredPlugins.get(pluginName);

    if (plugin === null || plugin === void 0 ? void 0 : plugin.platforms.has(getPlatform())) {
      // JS implementation available for the current platform.
      return true;
    }

    if (getPluginHeader(pluginName)) {
      // Native implementation available.
      return true;
    }

    return false;
  };

  var isPluginAvailable = ((_c = capPlatforms === null || capPlatforms === void 0 ? void 0 : capPlatforms.currentPlatform) === null || _c === void 0 ? void 0 : _c.isPluginAvailable) || defaultIsPluginAvailable;

  var defaultGetPluginHeader = function defaultGetPluginHeader(pluginName) {
    var _a;

    return (_a = cap.PluginHeaders) === null || _a === void 0 ? void 0 : _a.find(function (h) {
      return h.name === pluginName;
    });
  };

  var getPluginHeader = ((_d = capPlatforms === null || capPlatforms === void 0 ? void 0 : capPlatforms.currentPlatform) === null || _d === void 0 ? void 0 : _d.getPluginHeader) || defaultGetPluginHeader;

  var handleError = function handleError(err) {
    return win.console.error(err);
  };

  var pluginMethodNoop = function pluginMethodNoop(_target, prop, pluginName) {
    return Promise.reject("".concat(pluginName, " does not have an implementation of \"").concat(prop, "\"."));
  };

  var registeredPlugins = new Map();

  var defaultRegisterPlugin = function defaultRegisterPlugin(pluginName) {
    var jsImplementations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var registeredPlugin = registeredPlugins.get(pluginName);

    if (registeredPlugin) {
      console.warn("Capacitor plugin \"".concat(pluginName, "\" already registered. Cannot register plugins twice."));
      return registeredPlugin.proxy;
    }

    var platform = getPlatform();
    var pluginHeader = getPluginHeader(pluginName);
    var jsImplementation;

    var loadPluginImplementation =
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!jsImplementation && platform in jsImplementations)) {
                  _context.next = 11;
                  break;
                }

                if (!(typeof jsImplementations[platform] === 'function')) {
                  _context.next = 7;
                  break;
                }

                _context.next = 4;
                return jsImplementations[platform]();

              case 4:
                _context.t0 = jsImplementation = _context.sent;
                _context.next = 8;
                break;

              case 7:
                _context.t0 = jsImplementation = jsImplementations[platform];

              case 8:
                jsImplementation = _context.t0;
                _context.next = 20;
                break;

              case 11:
                if (!(capCustomPlatform !== null && !jsImplementation && 'web' in jsImplementations)) {
                  _context.next = 20;
                  break;
                }

                if (!(typeof jsImplementations['web'] === 'function')) {
                  _context.next = 18;
                  break;
                }

                _context.next = 15;
                return jsImplementations['web']();

              case 15:
                _context.t1 = jsImplementation = _context.sent;
                _context.next = 19;
                break;

              case 18:
                _context.t1 = jsImplementation = jsImplementations['web'];

              case 19:
                jsImplementation = _context.t1;

              case 20:
                return _context.abrupt("return", jsImplementation);

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function loadPluginImplementation() {
        return _ref.apply(this, arguments);
      };
    }();

    var createPluginMethod = function createPluginMethod(impl, prop) {
      var _a, _b;

      if (pluginHeader) {
        var methodHeader = pluginHeader === null || pluginHeader === void 0 ? void 0 : pluginHeader.methods.find(function (m) {
          return prop === m.name;
        });

        if (methodHeader) {
          if (methodHeader.rtype === 'promise') {
            return function (options) {
              return cap.nativePromise(pluginName, prop.toString(), options);
            };
          } else {
            return function (options, callback) {
              return cap.nativeCallback(pluginName, prop.toString(), options, callback);
            };
          }
        } else if (impl) {
          return (_a = impl[prop]) === null || _a === void 0 ? void 0 : _a.bind(impl);
        }
      } else if (impl) {
        return (_b = impl[prop]) === null || _b === void 0 ? void 0 : _b.bind(impl);
      } else {
        throw new CapacitorException("\"".concat(pluginName, "\" plugin is not implemented on ").concat(platform), ExceptionCode.Unimplemented);
      }
    };

    var createPluginMethodWrapper = function createPluginMethodWrapper(prop) {
      var remove;

      var wrapper = function wrapper() {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var p = loadPluginImplementation().then(function (impl) {
          var fn = createPluginMethod(impl, prop);

          if (fn) {
            var _p = fn.apply(void 0, args);

            remove = _p === null || _p === void 0 ? void 0 : _p.remove;
            return _p;
          } else {
            throw new CapacitorException("\"".concat(pluginName, ".").concat(prop, "()\" is not implemented on ").concat(platform), ExceptionCode.Unimplemented);
          }
        });

        if (prop === 'addListener') {
          p.remove =
          /*#__PURE__*/
          _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee2() {
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    return _context2.abrupt("return", remove());

                  case 1:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));
        }

        return p;
      }; // Some flair ✨


      wrapper.toString = function () {
        return "".concat(prop.toString(), "() { [capacitor code] }");
      };

      Object.defineProperty(wrapper, 'name', {
        value: prop,
        writable: false,
        configurable: false
      });
      return wrapper;
    };

    var addListener = createPluginMethodWrapper('addListener');
    var removeListener = createPluginMethodWrapper('removeListener');

    var addListenerNative = function addListenerNative(eventName, callback) {
      var call = addListener({
        eventName: eventName
      }, callback);

      var remove =
      /*#__PURE__*/
      function () {
        var _ref3 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee3() {
          var callbackId;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return call;

                case 2:
                  callbackId = _context3.sent;
                  removeListener({
                    eventName: eventName,
                    callbackId: callbackId
                  }, callback);

                case 4:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function remove() {
          return _ref3.apply(this, arguments);
        };
      }();

      var p = new Promise(function (resolve) {
        return call.then(function () {
          return resolve({
            remove: remove
          });
        });
      });
      p.remove =
      /*#__PURE__*/
      _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                console.warn("Using addListener() without 'await' is deprecated.");
                _context4.next = 3;
                return remove();

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      return p;
    };

    var proxy = new Proxy({}, {
      get: function get(_, prop) {
        switch (prop) {
          // https://github.com/facebook/react/issues/20030
          case '$$typeof':
            return undefined;

          case 'toJSON':
            return function () {
              return {};
            };

          case 'addListener':
            return pluginHeader ? addListenerNative : addListener;

          case 'removeListener':
            return removeListener;

          default:
            return createPluginMethodWrapper(prop);
        }
      }
    });
    Plugins[pluginName] = proxy;
    registeredPlugins.set(pluginName, {
      name: pluginName,
      proxy: proxy,
      platforms: new Set([].concat(_toConsumableArray(Object.keys(jsImplementations)), _toConsumableArray(pluginHeader ? [platform] : [])))
    });
    return proxy;
  };

  var registerPlugin = ((_e = capPlatforms === null || capPlatforms === void 0 ? void 0 : capPlatforms.currentPlatform) === null || _e === void 0 ? void 0 : _e.registerPlugin) || defaultRegisterPlugin; // Add in convertFileSrc for web, it will already be available in native context

  if (!cap.convertFileSrc) {
    cap.convertFileSrc = function (filePath) {
      return filePath;
    };
  }

  cap.getPlatform = getPlatform;
  cap.handleError = handleError;
  cap.isNativePlatform = isNativePlatform;
  cap.isPluginAvailable = isPluginAvailable;
  cap.pluginMethodNoop = pluginMethodNoop;
  cap.registerPlugin = registerPlugin;
  cap.Exception = CapacitorException;
  cap.DEBUG = !!cap.DEBUG;
  cap.isLoggingEnabled = !!cap.isLoggingEnabled; // Deprecated props

  cap.platform = cap.getPlatform();
  cap.isNative = cap.isNativePlatform();
  return cap;
};

var initCapacitorGlobal = function initCapacitorGlobal(win) {
  return win.Capacitor = createCapacitor(win);
};

var Capacitor =
/*#__PURE__*/
initCapacitorGlobal(typeof globalThis !== 'undefined' ? globalThis : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {});
var registerPlugin = Capacitor.registerPlugin;
/**
 * @deprecated Provided for backwards compatibility for Capacitor v2 plugins.
 * Capacitor v3 plugins should import the plugin directly. This "Plugins"
 * export is deprecated in v3, and will be removed in v4.
 */

var Plugins = Capacitor.Plugins;
/**
 * Provided for backwards compatibility. Use the registerPlugin() API
 * instead, and provide the web plugin as the "web" implmenetation.
 * For example
 *
 * export const Example = registerPlugin('Example', {
 *   web: () => import('./web').then(m => new m.Example())
 * })
 *
 * @deprecated Deprecated in v3, will be removed from v4.
 */

var registerWebPlugin = function registerWebPlugin(plugin) {
  return legacyRegisterWebPlugin(Capacitor, plugin);
};
/**
 * Base class web plugins should extend.
 */


var WebPlugin =
/*#__PURE__*/
function () {
  function WebPlugin(config) {
    _classCallCheck(this, WebPlugin);

    this.listeners = {};
    this.windowListeners = {};

    if (config) {
      // TODO: add link to upgrade guide
      console.warn("Capacitor WebPlugin \"".concat(config.name, "\" config object was deprecated in v3 and will be removed in v4."));
      this.config = config;
    }
  }

  _createClass(WebPlugin, [{
    key: "addListener",
    value: function addListener(eventName, listenerFunc) {
      var _this2 = this;

      var listeners = this.listeners[eventName];

      if (!listeners) {
        this.listeners[eventName] = [];
      }

      this.listeners[eventName].push(listenerFunc); // If we haven't added a window listener for this event and it requires one,
      // go ahead and add it

      var windowListener = this.windowListeners[eventName];

      if (windowListener && !windowListener.registered) {
        this.addWindowListener(windowListener);
      }

      var remove =
      /*#__PURE__*/
      function () {
        var _ref5 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee5() {
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  return _context5.abrupt("return", _this2.removeListener(eventName, listenerFunc));

                case 1:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));

        return function remove() {
          return _ref5.apply(this, arguments);
        };
      }();

      var p = Promise.resolve({
        remove: remove
      });
      Object.defineProperty(p, 'remove', {
        value: function () {
          var _value = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee6() {
            return _regeneratorRuntime.wrap(function _callee6$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    console.warn("Using addListener() without 'await' is deprecated.");
                    _context6.next = 3;
                    return remove();

                  case 3:
                  case "end":
                    return _context6.stop();
                }
              }
            }, _callee6);
          }));

          function value() {
            return _value.apply(this, arguments);
          }

          return value;
        }()
      });
      return p;
    }
  }, {
    key: "removeAllListeners",
    value: function () {
      var _removeAllListeners = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        var listener;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                this.listeners = {};

                for (listener in this.windowListeners) {
                  this.removeWindowListener(this.windowListeners[listener]);
                }

                this.windowListeners = {};

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function removeAllListeners() {
        return _removeAllListeners.apply(this, arguments);
      }

      return removeAllListeners;
    }()
  }, {
    key: "notifyListeners",
    value: function notifyListeners(eventName, data) {
      var listeners = this.listeners[eventName];

      if (listeners) {
        listeners.forEach(function (listener) {
          return listener(data);
        });
      }
    }
  }, {
    key: "hasListeners",
    value: function hasListeners(eventName) {
      return !!this.listeners[eventName].length;
    }
  }, {
    key: "registerWindowListener",
    value: function registerWindowListener(windowEventName, pluginEventName) {
      var _this3 = this;

      this.windowListeners[pluginEventName] = {
        registered: false,
        windowEventName: windowEventName,
        pluginEventName: pluginEventName,
        handler: function handler(event) {
          _this3.notifyListeners(pluginEventName, event);
        }
      };
    }
  }, {
    key: "unimplemented",
    value: function unimplemented() {
      var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'not implemented';
      return new Capacitor.Exception(msg, ExceptionCode.Unimplemented);
    }
  }, {
    key: "unavailable",
    value: function unavailable() {
      var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'not available';
      return new Capacitor.Exception(msg, ExceptionCode.Unavailable);
    }
  }, {
    key: "removeListener",
    value: function () {
      var _removeListener = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8(eventName, listenerFunc) {
        var listeners, index;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                listeners = this.listeners[eventName];

                if (listeners) {
                  _context8.next = 3;
                  break;
                }

                return _context8.abrupt("return");

              case 3:
                index = listeners.indexOf(listenerFunc);
                this.listeners[eventName].splice(index, 1); // If there are no more listeners for this type of event,
                // remove the window listener

                if (!this.listeners[eventName].length) {
                  this.removeWindowListener(this.windowListeners[eventName]);
                }

              case 6:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function removeListener(_x, _x2) {
        return _removeListener.apply(this, arguments);
      }

      return removeListener;
    }()
  }, {
    key: "addWindowListener",
    value: function addWindowListener(handle) {
      window.addEventListener(handle.windowEventName, handle.handler);
      handle.registered = true;
    }
  }, {
    key: "removeWindowListener",
    value: function removeWindowListener(handle) {
      if (!handle) {
        return;
      }

      window.removeEventListener(handle.windowEventName, handle.handler);
      handle.registered = false;
    }
  }]);

  return WebPlugin;
}();

var WebView =
/*#__PURE__*/
registerPlugin('WebView');
/******** END WEB VIEW PLUGIN ********/

/******** COOKIES PLUGIN ********/

/**
 * Safely web encode a string value (inspired by js-cookie)
 * @param str The string value to encode
 */

var encode = function encode(str) {
  return encodeURIComponent(str).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
};
/**
 * Safely web decode a string value (inspired by js-cookie)
 * @param str The string value to decode
 */


var decode = function decode(str) {
  return str.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
};

var CapacitorCookiesPluginWeb =
/*#__PURE__*/
function (_WebPlugin) {
  _inherits(CapacitorCookiesPluginWeb, _WebPlugin);

  function CapacitorCookiesPluginWeb() {
    _classCallCheck(this, CapacitorCookiesPluginWeb);

    return _possibleConstructorReturn(this, _getPrototypeOf(CapacitorCookiesPluginWeb).apply(this, arguments));
  }

  _createClass(CapacitorCookiesPluginWeb, [{
    key: "getCookies",
    value: function () {
      var _getCookies = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9() {
        var cookies, cookieMap;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                cookies = document.cookie;
                cookieMap = {};
                cookies.split(';').forEach(function (cookie) {
                  if (cookie.length <= 0) return; // Replace first "=" with CAP_COOKIE to prevent splitting on additional "="

                  var _cookie$replace$split = cookie.replace(/=/, 'CAP_COOKIE').split('CAP_COOKIE'),
                      _cookie$replace$split2 = _slicedToArray(_cookie$replace$split, 2),
                      key = _cookie$replace$split2[0],
                      value = _cookie$replace$split2[1];

                  key = decode(key).trim();
                  value = decode(value).trim();
                  cookieMap[key] = value;
                });
                return _context9.abrupt("return", cookieMap);

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      function getCookies() {
        return _getCookies.apply(this, arguments);
      }

      return getCookies;
    }()
  }, {
    key: "setCookie",
    value: function () {
      var _setCookie = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10(options) {
        var encodedKey, encodedValue, expires, path, domain;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                // Safely Encoded Key/Value
                encodedKey = encode(options.key);
                encodedValue = encode(options.value); // Clean & sanitize options

                expires = "; expires=".concat((options.expires || '').replace('expires=', '')); // Default is "; expires="

                path = (options.path || '/').replace('path=', ''); // Default is "path=/"

                domain = options.url != null && options.url.length > 0 ? "domain=".concat(options.url) : '';
                document.cookie = "".concat(encodedKey, "=").concat(encodedValue || '').concat(expires, "; path=").concat(path, "; ").concat(domain, ";");
                _context10.next = 12;
                break;

              case 9:
                _context10.prev = 9;
                _context10.t0 = _context10["catch"](0);
                return _context10.abrupt("return", Promise.reject(_context10.t0));

              case 12:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, null, [[0, 9]]);
      }));

      function setCookie(_x3) {
        return _setCookie.apply(this, arguments);
      }

      return setCookie;
    }()
  }, {
    key: "deleteCookie",
    value: function () {
      var _deleteCookie = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11(options) {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                document.cookie = "".concat(options.key, "=; Max-Age=0");
                _context11.next = 7;
                break;

              case 4:
                _context11.prev = 4;
                _context11.t0 = _context11["catch"](0);
                return _context11.abrupt("return", Promise.reject(_context11.t0));

              case 7:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, null, [[0, 4]]);
      }));

      function deleteCookie(_x4) {
        return _deleteCookie.apply(this, arguments);
      }

      return deleteCookie;
    }()
  }, {
    key: "clearCookies",
    value: function () {
      var _clearCookies = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee12() {
        var cookies, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, cookie;

        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;
                cookies = document.cookie.split(';') || [];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context12.prev = 5;

                for (_iterator = cookies[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  cookie = _step.value;
                  document.cookie = cookie.replace(/^ +/, '').replace(/=.*/, "=;expires=".concat(new Date().toUTCString(), ";path=/"));
                }

                _context12.next = 13;
                break;

              case 9:
                _context12.prev = 9;
                _context12.t0 = _context12["catch"](5);
                _didIteratorError = true;
                _iteratorError = _context12.t0;

              case 13:
                _context12.prev = 13;
                _context12.prev = 14;

                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }

              case 16:
                _context12.prev = 16;

                if (!_didIteratorError) {
                  _context12.next = 19;
                  break;
                }

                throw _iteratorError;

              case 19:
                return _context12.finish(16);

              case 20:
                return _context12.finish(13);

              case 21:
                _context12.next = 26;
                break;

              case 23:
                _context12.prev = 23;
                _context12.t1 = _context12["catch"](0);
                return _context12.abrupt("return", Promise.reject(_context12.t1));

              case 26:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, null, [[0, 23], [5, 9, 13, 21], [14,, 16, 20]]);
      }));

      function clearCookies() {
        return _clearCookies.apply(this, arguments);
      }

      return clearCookies;
    }()
  }, {
    key: "clearAllCookies",
    value: function () {
      var _clearAllCookies = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee13() {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.prev = 0;
                _context13.next = 3;
                return this.clearCookies();

              case 3:
                _context13.next = 8;
                break;

              case 5:
                _context13.prev = 5;
                _context13.t0 = _context13["catch"](0);
                return _context13.abrupt("return", Promise.reject(_context13.t0));

              case 8:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this, [[0, 5]]);
      }));

      function clearAllCookies() {
        return _clearAllCookies.apply(this, arguments);
      }

      return clearAllCookies;
    }()
  }]);

  return CapacitorCookiesPluginWeb;
}(WebPlugin);

var CapacitorCookies = registerPlugin('CapacitorCookies', {
  web: function web() {
    return new CapacitorCookiesPluginWeb();
  }
}); // UTILITY FUNCTIONS

/**
 * Read in a Blob value and return it as a base64 string
 * @param blob The blob value to convert to a base64 string
 */

var readBlobAsBase64 =
/*#__PURE__*/
function () {
  var _ref6 = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee14(blob) {
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            return _context14.abrupt("return", new Promise(function (resolve, reject) {
              var reader = new FileReader();

              reader.onload = function () {
                var base64String = reader.result; // remove prefix "data:application/pdf;base64,"

                // remove prefix "data:application/pdf;base64,"
                resolve(base64String.indexOf(',') >= 0 ? base64String.split(',')[1] : base64String);
              };

              reader.onerror = function (error) {
                return reject(error);
              };

              reader.readAsDataURL(blob);
            }));

          case 1:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));

  return function readBlobAsBase64(_x5) {
    return _ref6.apply(this, arguments);
  };
}();
/**
 * Normalize an HttpHeaders map by lowercasing all of the values
 * @param headers The HttpHeaders object to normalize
 */


var normalizeHttpHeaders = function normalizeHttpHeaders() {
  var headers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var originalKeys = Object.keys(headers);
  var loweredKeys = Object.keys(headers).map(function (k) {
    return k.toLocaleLowerCase();
  });
  var normalized = loweredKeys.reduce(function (acc, key, index) {
    acc[key] = headers[originalKeys[index]];
    return acc;
  }, {});
  return normalized;
};
/**
 * Builds a string of url parameters that
 * @param params A map of url parameters
 * @param shouldEncode true if you should encodeURIComponent() the values (true by default)
 */


var buildUrlParams = function buildUrlParams(params) {
  var shouldEncode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (!params) return null;
  var output = Object.entries(params).reduce(function (accumulator, entry) {
    var _entry = _slicedToArray(entry, 2),
        key = _entry[0],
        value = _entry[1];

    var encodedValue;
    var item;

    if (Array.isArray(value)) {
      item = '';
      value.forEach(function (str) {
        encodedValue = shouldEncode ? encodeURIComponent(str) : str;
        item += "".concat(key, "=").concat(encodedValue, "&");
      }); // last character will always be "&" so slice it off

      item.slice(0, -1);
    } else {
      encodedValue = shouldEncode ? encodeURIComponent(value) : value;
      item = "".concat(key, "=").concat(encodedValue);
    }

    return "".concat(accumulator, "&").concat(item);
  }, ''); // Remove initial "&" from the reduce

  return output.substr(1);
};
/**
 * Build the RequestInit object based on the options passed into the initial request
 * @param options The Http plugin options
 * @param extra Any extra RequestInit values
 */


var buildRequestInit = function buildRequestInit(options) {
  var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var output = Object.assign({
    method: options.method || 'GET',
    headers: options.headers
  }, extra); // Get the content-type

  var headers = normalizeHttpHeaders(options.headers);
  var type = headers['content-type'] || ''; // If body is already a string, then pass it through as-is.

  if (typeof options.data === 'string') {
    output.body = options.data;
  } // Build request initializers based off of content-type
  else if (type.includes('application/x-www-form-urlencoded')) {
      var params = new URLSearchParams();

      for (var _i = 0, _Object$entries = Object.entries(options.data || {}); _i < _Object$entries.length; _i++) {
        var _ref9 = _Object$entries[_i];

        var _ref8 = _slicedToArray(_ref9, 2);

        var key = _ref8[0];
        var value = _ref8[1];
        params.set(key, value);
      }

      output.body = params.toString();
    } else if (type.includes('multipart/form-data')) {
      var form = new FormData();

      if (options.data instanceof FormData) {
        options.data.forEach(function (value, key) {
          form.append(key, value);
        });
      } else {
        for (var _i2 = 0, _Object$keys = Object.keys(options.data); _i2 < _Object$keys.length; _i2++) {
          var _key2 = _Object$keys[_i2];
          form.append(_key2, options.data[_key2]);
        }
      }

      output.body = form;

      var _headers = new Headers(output.headers);

      _headers.delete('content-type'); // content-type will be set by `window.fetch` to includy boundary


      output.headers = _headers;
    } else if (type.includes('application/json') || typeof options.data === 'object') {
      output.body = JSON.stringify(options.data);
    }

  return output;
}; // WEB IMPLEMENTATION


var CapacitorHttpPluginWeb =
/*#__PURE__*/
function (_WebPlugin2) {
  _inherits(CapacitorHttpPluginWeb, _WebPlugin2);

  function CapacitorHttpPluginWeb() {
    _classCallCheck(this, CapacitorHttpPluginWeb);

    return _possibleConstructorReturn(this, _getPrototypeOf(CapacitorHttpPluginWeb).apply(this, arguments));
  }

  _createClass(CapacitorHttpPluginWeb, [{
    key: "request",

    /**
     * Perform an Http request given a set of options
     * @param options Options to build the HTTP request
     */
    value: function () {
      var _request = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee15(options) {
        var requestInit, urlParams, url, response, contentType, _ref10, _ref10$responseType, responseType, data, blob, headers;

        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                requestInit = buildRequestInit(options, options.webFetchExtra);
                urlParams = buildUrlParams(options.params, options.shouldEncodeUrlParams);
                url = urlParams ? "".concat(options.url, "?").concat(urlParams) : options.url;
                _context15.next = 5;
                return fetch(url, requestInit);

              case 5:
                response = _context15.sent;
                contentType = response.headers.get('content-type') || ''; // Default to 'text' responseType so no parsing happens

                _ref10 = response.ok ? options : {}, _ref10$responseType = _ref10.responseType, responseType = _ref10$responseType === void 0 ? 'text' : _ref10$responseType; // If the response content-type is json, force the response to be json

                if (contentType.includes('application/json')) {
                  responseType = 'json';
                }

                _context15.t0 = responseType;
                _context15.next = _context15.t0 === 'arraybuffer' ? 12 : _context15.t0 === 'blob' ? 12 : _context15.t0 === 'json' ? 19 : _context15.t0 === 'document' ? 23 : _context15.t0 === 'text' ? 23 : 23;
                break;

              case 12:
                _context15.next = 14;
                return response.blob();

              case 14:
                blob = _context15.sent;
                _context15.next = 17;
                return readBlobAsBase64(blob);

              case 17:
                data = _context15.sent;
                return _context15.abrupt("break", 26);

              case 19:
                _context15.next = 21;
                return response.json();

              case 21:
                data = _context15.sent;
                return _context15.abrupt("break", 26);

              case 23:
                _context15.next = 25;
                return response.text();

              case 25:
                data = _context15.sent;

              case 26:
                // Convert fetch headers to Capacitor HttpHeaders
                headers = {};
                response.headers.forEach(function (value, key) {
                  headers[key] = value;
                });
                return _context15.abrupt("return", {
                  data: data,
                  headers: headers,
                  status: response.status,
                  url: response.url
                });

              case 29:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15);
      }));

      function request(_x6) {
        return _request.apply(this, arguments);
      }

      return request;
    }()
    /**
     * Perform an Http GET request given a set of options
     * @param options Options to build the HTTP request
     */

  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee16(options) {
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                return _context16.abrupt("return", this.request(Object.assign(Object.assign({}, options), {
                  method: 'GET'
                })));

              case 1:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function get(_x7) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
    /**
     * Perform an Http POST request given a set of options
     * @param options Options to build the HTTP request
     */

  }, {
    key: "post",
    value: function () {
      var _post = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee17(options) {
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                return _context17.abrupt("return", this.request(Object.assign(Object.assign({}, options), {
                  method: 'POST'
                })));

              case 1:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function post(_x8) {
        return _post.apply(this, arguments);
      }

      return post;
    }()
    /**
     * Perform an Http PUT request given a set of options
     * @param options Options to build the HTTP request
     */

  }, {
    key: "put",
    value: function () {
      var _put = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee18(options) {
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                return _context18.abrupt("return", this.request(Object.assign(Object.assign({}, options), {
                  method: 'PUT'
                })));

              case 1:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function put(_x9) {
        return _put.apply(this, arguments);
      }

      return put;
    }()
    /**
     * Perform an Http PATCH request given a set of options
     * @param options Options to build the HTTP request
     */

  }, {
    key: "patch",
    value: function () {
      var _patch = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee19(options) {
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                return _context19.abrupt("return", this.request(Object.assign(Object.assign({}, options), {
                  method: 'PATCH'
                })));

              case 1:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function patch(_x10) {
        return _patch.apply(this, arguments);
      }

      return patch;
    }()
    /**
     * Perform an Http DELETE request given a set of options
     * @param options Options to build the HTTP request
     */

  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee20(options) {
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                return _context20.abrupt("return", this.request(Object.assign(Object.assign({}, options), {
                  method: 'DELETE'
                })));

              case 1:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function _delete(_x11) {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }]);

  return CapacitorHttpPluginWeb;
}(WebPlugin);

var CapacitorHttp = registerPlugin('CapacitorHttp', {
  web: function web() {
    return new CapacitorHttpPluginWeb();
  }
});
/******** END HTTP PLUGIN ********/

export { Capacitor, CapacitorCookies, CapacitorException, CapacitorHttp, CapacitorPlatforms, ExceptionCode, Plugins, WebPlugin, WebView, addPlatform, registerPlugin, registerWebPlugin, setPlatform };